import React, { useState } from "react";
import professional from "../img/svg/professional.svg";
import AboutApi from "../api/AboutApi.js";
import PageTitle from "../api/PageTitle";
const About = () => {
  const [aboutData] = useState(AboutApi);
  return (
    <>
      <PageTitle name="About" link="Home" page="About" />

      <div className="about-container">
        <span>
          <p className="about-p1">Work Process</p>
          <h1 className="about-h1">How it Works?</h1>
        </span>
        <p className="about-p2">
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Maiores
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Maiores
          labore quidem dolor laboriosam, voluptatum eligendi.
        </p>
        <button className="about-button">Make Appointment</button>
      </div>

      <div className="about-cards">
        {aboutData.map((curEle) => {
          return (
            <>
              <div className="about-card-1">
                <img src={professional} alt="" className="about-card-img" />
                <span className="about-card-content">
                  <h3 className="about-h2">{curEle.heading}</h3>
                  <p className="about-p3">{curEle.description}</p>
                </span>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default About;
